import {
  allocateSchedule as allocateScheduleAPI,
  updateTimesheetTask as updateTimesheetTaskAPI,
  allocateResource as allocateResourceAPI,
  deleteResource as deleteResourceAPI,
  getResourceAllocations as getResourceAllocationsAPI,
  approveTimesheet as approveTimesheetAPI,
  deleteResources as deleteResourcesAPI,
  editTimesheet as editTimesheetAPI,
  applyLeave as applyLeaveAPI,
  getUserLeaves as getUserLeavesAPI,
  bulkUpdateTimesheet as bulkUpdateTimesheetAPI,
  importTimesheet as importTimesheetAPI,
  modifyAllocation as modifyAllocationAPI,
  getTimesheetAuditLogs as getTimesheetAuditLogsAPI,
  recalculateTimesheets as recalculateTimesheetsAPI
} from '../api/timesheet.api'

export const allocateResource = (data) => {
  return (dispatch, getState) => {
    return allocateResourceAPI(data)
  }
}

export const importTimesheet = (data) => {
  return (dispatch, getState) => {
    return importTimesheetAPI(data)
  }
}

export const allocateSchedule = (data) => {
  return (dispatch, getState) => {
    return allocateScheduleAPI(data)
  }
}
export const updateTimesheetTask = (data) => {
  return (dispatch, getState) => {
    return updateTimesheetTaskAPI(data)
  }
}
export const deleteResource = (type, allocationId) => {
  return (dispatch, getState) => {
    return deleteResourceAPI(type, allocationId)
  }
}

export const deleteResources = (type, allocationIds) => {
  return (dispatch, getState) => {
    return deleteResourcesAPI(type, allocationIds)
  }
}

export const getResourceAllocations = (params) => {
  return (dispatch, getState) => {
    if (!params.allowedModules) {
      params['allowedModules'] = getState().project.allowedModules || [];
    }
    return getResourceAllocationsAPI(params)
  }
}

export const approveTimesheet = (id, data) => {
  return (dispatch, getState) => {
    return approveTimesheetAPI(id, data)
  }
}

export const bulkUpdateTimesheet = (data) => {
  return (dispatch, getState) => {
    return bulkUpdateTimesheetAPI(data)
  }
}

export const editTimesheet = (id, data) => {
  return (dispatch, getState) => {
    return editTimesheetAPI(id, data)
  }
}

export const applyLeave = (data) => {
  return (dispatch, getState) => {
    return applyLeaveAPI(data)
  }
}

export const getUserLeaves = (params) => {
  return (dispatch, getState) => {
    return getUserLeavesAPI(params)
  }
}
export const modifyAllocation = (data) => {
  return (dispatch, getState) => {
    return modifyAllocationAPI(data);
  };
};

export const getTimesheetAuditLogs = (timesheetId) => {
  return (dispatch, getState) => {
    return getTimesheetAuditLogsAPI(timesheetId);
  };
};

export const recalculateTimesheets = (allocationIds) => {
  return (dispatch, getState) => {
    return recalculateTimesheetsAPI(allocationIds);
  };
};
